const heroWithVideo = {
    title: "Notariat simplificat, cu Enotar",
    subtitle: "Descoperă cum Enotar revoluționează managementul notarial",
    videoSrc: "./videos/hero-video.mp4",
    buttonText: "Începe Acum",
    buttonLink: "/signup"
};

export default heroWithVideo;